// extracted by mini-css-extract-plugin
module.exports = {"profile":"profile_profile__VRUGu","profile__right":"profile_profile__right__3jGwi"};